import * as yup from "yup";

const validationSchema = yup.object({
  brand: yup.string().required(),
  month: yup.date().required(),
  goalAmount: yup.number().min(0).required(),
});

const formikSchema = (goal, thisDate) => ({
  initialValues: {
    sosToExclude: goal?.sosToExclude ?? [],
    brand: goal?.brand?.id ?? "",
    goalAmount: goal?.goalAmount,
    notes: goal?.notes,
    month: goal?.month || thisDate,
    customSos: goal?.customSos?.map((s) => s.id) || [],
    isNew: false,
    openToAllSos: goal.openToAllSos,
  },
  validationSchema,
});

export { formikSchema, validationSchema };
